import { Component, OnInit } from '@angular/core';
// Import global data service
import { DataService } from 'src/app/Services/Data/data.service';
import { HelperService } from 'src/app/Services/HelperService/helper.service';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.sass']
})
export class StatusComponent implements OnInit {
  constructor(private dataService: DataService, private helperService: HelperService) {}

  statuses: any = [];
  logs: any = [];
  routing_details: any = [];
  loading: boolean;
  loadingMessage: string;
  display_replace_signer_modal: boolean;
  display_advance_settings_modal: boolean;
  advance_settings_role_selected: boolean;
  is_show_canceled: boolean = false;
  selected_option_document_field_invites_initial_state: any = []; // used for comparing before saving
  selected_option_document_field_invites: any = [];
  selected_advance_settings_field_invite: any = [];
  selected_document_id: any;
  selected_status: any;
  new_password: any;
  // error
  error_messages: any = [];
  // sending bulk invite
  sending_bulk_invite: boolean;
  // show logs
  is_show_logs: boolean = false;
  salesforce_session_data: any;

  // Height of Canvas
  status_height: any = 450;

  isPushedbackLogOpen = false;
  currentPushedbackLog: any = {};

  errorMessages = {
    invalidReminder:
      'Please use a valid reminder value! If you wish to not use reminders please enter 0 for the reminder value!',
    invalidExpiration: 'Please use a valid expiration value.',
    invalidEmail: 'Please enter valid invite email!',
    invitePassword:
      'Replacing Signer resets the invite password. Please select Advanced Settings to add a password again.',
    badLoadStatuses: 'Something went wrong. Please try to reload page.',
    somethingWrong: 'Something went wrong. Please try again.',
    badAdvancedSettingsUpdate: 'Something went wrong. Please try again.'
  };

  async ngOnInit() {
    this.loadingMessage = 'Retrieving this records document statuses.';
    this.loading = true;
    this.display_advance_settings_modal = false;
    this.advance_settings_role_selected = false;
    this.display_replace_signer_modal = false;
    this.sending_bulk_invite = false;
    await this.loadSalesforceData();
    this.getDocumentStatuses();
  }

  clearErrorMessages() {
    this.error_messages = [];
  }

  removeErrorMessage(error_message) {
    for (let i = 0; i < this.error_messages.length; i++) {
      if (error_message === this.error_messages[i]) {
        // delete this.error_messages[i];
        this.error_messages.splice(i, 1);
      }
    }
  }
  updateError(msg: string) {
    this.error_messages.push(msg);
  }

  actionHandler({ selectedOption, data: selected_status }) {
    this.openModal(selectedOption, selected_status);
  }

  openModal(selected_value, selected_status) {
    this.clearErrorMessages();

    switch (selected_value) {
      case 'replace_signer': {
        this.updateLoading(true, 'Getting signer data');
        this.selected_status = selected_status;
        this.replaceSigner(selected_status.document_id);
        break;
      }
      case 'advance_settings': {
        this.updateLoading(true, 'Getting advanced settings');
        this.selected_status = selected_status;
        this.advanceSettings(selected_status.document_id);
        break;
      }
      case 'cancel_invite': {
        this.updateLoading(true, 'Canceling invite');
        this.selected_status = selected_status;
        this.cancelInvite(selected_status.document_id);
        break;
      }
      case 'cancel_group_invite': {
        this.updateLoading(true, 'Canceling invite');
        this.selected_status = selected_status;
        this.cancelGroupInvite(selected_status.group_id, selected_status.invite_id);
        break;
      }
      case 'download_with_history': {
        const document_id = selected_status.document_id;
        const url = window.location.origin + '/api/download?document_id=' + document_id + '&get_history=true';
        window.open(url);
        this.selected_status = [];
        this.hideAllModalsAndRealoadPage();
        break;
      }
      case 'download': {
        const document_id = selected_status.document_id;
        const url =
          window.location.origin + '/api/download?document_id=' + document_id + '&get_history=false';
        window.open(url);
        this.selected_status = [];
        this.hideAllModalsAndRealoadPage();
        break;
      }
      default: {
        this.selected_status = [];
        break;
      }
    }
  }

  hideAllModalsAndRealoadPage() {
    this.display_advance_settings_modal = false;
    this.display_replace_signer_modal = false;
    this.advance_settings_role_selected = false;
    this.reloadStatuses();
  }

  hideAllModals() {
    this.display_advance_settings_modal = false;
    this.display_replace_signer_modal = false;
    this.advance_settings_role_selected = false;
  }

  replaceSigner(document_id) {
    this.selected_document_id = document_id;
    this.dataService
      .apiGetCall('/api/get_document?document_id=' + document_id)

      .subscribe(
        (document) => {
          this.selected_option_document_field_invites = this.sortFieldInvitesByRoleName(
            document.field_invites
          );
          this.selected_option_document_field_invites_initial_state = JSON.parse(
            JSON.stringify(document.field_invites)
          ); // deep copy

          this.display_replace_signer_modal = true;
        },
        () => this.updateError(this.errorMessages.somethingWrong),
        () => this.updateLoading(false)
      );
  }

  advanceSettings(document_id) {
    this.selected_document_id = document_id;
    this.dataService
      .apiGetCall('/api/get_document?document_id=' + document_id)

      .subscribe(
        (document) => {
          this.selected_option_document_field_invites = this.sortFieldInvitesByRoleName(
            document.field_invites
          );
          for (let i = 0; i < this.selected_option_document_field_invites.length; i++) {
            if (
              this.selected_option_document_field_invites[i].expiration_time == null ||
              this.selected_option_document_field_invites.expiration_time
            ) {
              for (let j = 0; j < this.selected_status.emails.length; j++) {
                if (
                  this.selected_option_document_field_invites[i].role_id ===
                  this.selected_status.emails[j].sn_role_id
                ) {
                  const current_date = new Date(Date.now());
                  const parts = this.selected_status.emails[j].expiration.split('/');
                  const expiration_date = new Date(parts[2], parts[0] - 1, parts[1]);
                  const days_until_expiration = this.daysBetweenTwoDates(current_date, expiration_date);
                  if (days_until_expiration >= 0) {
                    this.selected_option_document_field_invites[i].expiration_time = days_until_expiration;
                  } else {
                    this.selected_option_document_field_invites[i].expiration_time = 0;
                  }
                }
              }
            }
          }
          for (let i = this.selected_option_document_field_invites.length - 1; i >= 0; --i) {
            this.selected_option_document_field_invites[i].reassign =
              !!+this.selected_option_document_field_invites[i].reassign;
          }

          this.display_advance_settings_modal = true;
          this.advance_settings_role_selected = false;
        },
        () => this.updateError(this.errorMessages.somethingWrong),
        () => this.updateLoading(false)
      );
  }

  updateReplaceSigners() {
    this.clearErrorMessages();

    const replace_signer_data: any = [];
    let is_pass_protected: boolean = false;
    let role: any;

    for (let i = 0; i < this.selected_option_document_field_invites.length; i++) {
      const email = this.selected_option_document_field_invites[i].email;
      if (!this.validateEmail(email)) {
        this.updateError(this.errorMessages.invalidEmail);
        this.hideAllModals();
        return;
      }
    }

    this.updateLoading(true, 'Updating Replace Signer');
    this.display_replace_signer_modal = false;
    const selected_status_copy = JSON.parse(JSON.stringify(this.selected_status));

    for (let i = 0; i < selected_status_copy.emails.length; i++) {
      // convert expiration back to timestamp / 1000
      selected_status_copy.emails[i].expiration = Math.floor(
        new Date(selected_status_copy.emails[i].expiration).getTime() / 1000
      );
    }

    for (let i = 0; i < this.selected_option_document_field_invites.length; i++) {
      if (
        this.selected_option_document_field_invites[i].email !==
        this.selected_option_document_field_invites_initial_state[i].email
      ) {
        if (
          this.selected_option_document_field_invites[i].password_protected !== 0 ||
          this.selected_option_document_field_invites[i].password_protected !== '0'
        ) {
          is_pass_protected = true;
        }

        if (parseInt(this.selected_option_document_field_invites[i].expiration_time, 10) >= 0) {
          const current_date = new Date(Date.now());
          const expiration_date = this.convertUnixToDateObject(
            this.selected_option_document_field_invites[i].expiration_time
          );
          const days_until_expiration = this.daysBetweenTwoDates(current_date, expiration_date);

          if (days_until_expiration >= 0) {
            this.selected_option_document_field_invites[i].expiration_time = days_until_expiration;
          } else {
            this.selected_option_document_field_invites[i].expiration_time = 0;
          }
        } else {
          this.selected_option_document_field_invites[i].expiration_time = 30;
        }

        role = {
          field_invite_id: this.selected_option_document_field_invites[i].id,
          role_id: this.selected_option_document_field_invites[i].role_id,
          email: this.selected_option_document_field_invites[i].email,
          is_replace: true,
          reassign: this.selected_option_document_field_invites[i].reassign,
          // expiration_days: this.selected_option_document_field_invites[i].expiration_time,
          reminder: 0 // replacing signer resets the reminder since there is no endpoint to get the reminder values when this was developed.
        };

        if (this.selected_option_document_field_invites[i].expiration_time) {
          role.expiration_days = this.selected_option_document_field_invites[i].expiration_time;
        }

        replace_signer_data.push(role);
      }
    }

    if (replace_signer_data.length) {
      this.dataService
        .apiPostCall(
          '/api/update_replace_signers?document_id=' + this.selected_document_id,
          JSON.stringify({ fields_invite_data: replace_signer_data, selected_status: selected_status_copy })
        )

        .subscribe(
          () => {
            this.hideAllModalsAndRealoadPage();
            if (is_pass_protected) {
              this.updateError(this.errorMessages.invitePassword);
            }
          },
          (error) => {
            this.hideAllModals();
            this.updateError(error.error);
          }
        );
    } else {
      this.hideAllModals();
      this.updateLoading(false);
    }
  }

  validateEmail(email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email) && email !== '';
  }

  updateAdvanceSettings() {
    this.clearErrorMessages();

    const password = this.new_password;
    this.new_password = '';
    const advance_settings_data: any = [];
    let role: any;
    let authentication_type;
    let exp_error = false;
    let rmd_error = false;

    const rmd_value = this.selected_advance_settings_field_invite.reminder;
    const exp_value = this.selected_advance_settings_field_invite.expiration_time;

    if (exp_value < 3 || exp_value > 180) {
      exp_error = true;
      this.updateError(this.errorMessages.invalidReminder);
    }

    if (rmd_value < 0 || rmd_value > 180 || rmd_value > exp_value) {
      rmd_error = true;
      this.updateError(this.errorMessages.invalidExpiration);
    }

    if (rmd_error || exp_error) {
      this.hideAllModals();
      return;
    }

    role = {
      field_invite_id: this.selected_advance_settings_field_invite.id,
      role_id: this.selected_advance_settings_field_invite.role_id,
      email: this.selected_advance_settings_field_invite.email,
      reassign: +this.selected_advance_settings_field_invite.reassign, // forwarding
      expiration_days: this.selected_advance_settings_field_invite.expiration_time,
      reminder: this.selected_advance_settings_field_invite.reminder,
      is_replace: true
    };

    if (password && password.length > 0) {
      authentication_type = 'password';
      role.authentication_type = authentication_type;
      role.password = password;
    }

    advance_settings_data.push(role);
    this.updateLoading(true, 'Updating Advanced Settings.');
    this.display_advance_settings_modal = false;

    const selected_status_copy = JSON.parse(JSON.stringify(this.selected_status));

    for (let i = 0; i < selected_status_copy.emails.length; i++) {
      // convert expiration back to timestamp / 1000
      selected_status_copy.emails[i].expiration = Math.floor(
        new Date(selected_status_copy.emails[i].expiration).getTime() / 1000
      );
    }

    this.dataService
      .apiPostCall(
        '/api/update_advance_settings?document_id=' + this.selected_document_id,
        JSON.stringify({ fields_invite_data: advance_settings_data, selected_status: selected_status_copy })
      )

      .subscribe(
        () => {
          this.hideAllModalsAndRealoadPage();
        },
        () => {
          this.hideLoading();
          this.updateError(this.errorMessages.badAdvancedSettingsUpdate);
        }
      );
  }

  convertUnixToDateObject(date) {
    return new Date(date * 1000);
  }

  roleSelectedForAdvanceSettings(field_invite) {
    if (field_invite.expiration_time == null || field_invite.expiration_time) {
      for (let j = 0; j < this.selected_status.emails.length; j++) {
        if (field_invite.role_id == this.selected_status.emails[j].sn_role_id) {
          const current_date = new Date(Date.now());
          const parts = this.selected_status.emails[j].expiration.split('/');
          const expiration_date = new Date(parts[2], parts[0] - 1, parts[1]);
          const days_until_expiration = this.daysBetweenTwoDates(current_date, expiration_date);
          if (days_until_expiration >= 0) {
            field_invite.expiration_time = days_until_expiration;
          } else {
            field_invite.expiration_time = 0;
          }
        }
      }
    } else {
      const current_date = new Date(Date.now());
      const expiration_date = this.convertUnixToDateObject(field_invite.expiration_time);
      const days_until_expiration = this.daysBetweenTwoDates(current_date, expiration_date);
      if (days_until_expiration >= 0) {
        field_invite.expiration_time = days_until_expiration;
      } else {
        field_invite.expiration_time = 0;
      }
    }

    this.selected_advance_settings_field_invite = field_invite;
    this.selected_advance_settings_field_invite.reminder = 0; // field invite reminder in the document is 0 or 1 not the number of days. For this reason I cant display this value as the number of days until the reminder.
    // this.selected_advance_settings_field_invite.reassign = !!field_invite.reassign; //forwarding;
    this.advance_settings_role_selected = true;
  }

  daysBetweenTwoDates(date1, date2) {
    const timeDiff = Math.abs(date1.getTime() - date2.getTime());
    const days_until_expiration = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return days_until_expiration;
  }
  cancelGroupInvite(group_id, invite_id) {
    this.dataService
      .apiPostCall(
        '/api/cancel_group_invite',
        JSON.stringify({ group_id: group_id, invite_id: invite_id, selected_status: this.selected_status })
      )

      .subscribe(() => {
        this.hideAllModalsAndRealoadPage();
      });
  }

  cancelInvite(document_id) {
    this.dataService
      .apiPostCall(
        '/api/cancel_invite',
        JSON.stringify({ document_id: document_id, selected_status: this.selected_status })
      )

      .subscribe(() => {
        this.hideAllModalsAndRealoadPage();
      });
  }

  deleteStatusRecord(document_id) {
    this.loading = true;
    this.dataService
      .apiGetCall('/api/delete_document_from_statuses?document_id=' + document_id)

      .subscribe(() => {
        this.reloadStatuses();
      });
  }

  reloadStatuses() {
    this.statuses = [];
    this.loading = true;
    this.loadingMessage = 'Reloading data';
    // await this.loadSalesforceData();
    this.getDocumentStatuses();
  }

  async loadSalesforceData() {
    try {
      this.salesforce_session_data = await this.dataService.loadSalesforceData();
      const context = this.salesforce_session_data.context;

      const environment = JSON.parse(context).environment;
      const canvas_height = parseInt(environment.dimensions.height.toLowerCase().replace('px', ''), 10) - 70;

      if (canvas_height >= 250) {
        this.status_height = canvas_height;
      } else {
        this.status_height = 450;
      }
    } catch {}
  }

  // async loadSalesforceDataFromParentFrameAndGetDocumentStatuses() {
  async getDocumentStatuses() {
    try {
      const { record_id, sf_token, instance_url, sf_org_id } = this.salesforce_session_data;

      // set information in data service
      const sn_email = this.dataService.getSignNowOwnerEmail();
      const offset = new Date().getTimezoneOffset();

      if (record_id === '') {
        this.loading = false;
        return;
      } else {
        this.dataService
          .apiPostCall('/api/get_logs?record_id=' + record_id, {
            sf_token: sf_token,
            instance_url: instance_url,
            sn_email: sn_email,
            sf_org_id: sf_org_id
          })

          .subscribe((result) => {
            this.logs = result;
          });

        // Get document statuses
        this.dataService
          .apiPostCall('/api/get_statuses?record_id=' + record_id, {
            sf_token: sf_token,
            instance_url: instance_url,
            sn_email: sn_email,
            sf_org_id: sf_org_id,
            offset: offset
          })

          .subscribe(
            (result) => {
              this.loading = false;
              // this.statuses = result;
              const added_docs: any = [];
              const added_group: any = [];
              try {
                this.sending_bulk_invite = result[0].sending_bulk_invite === true;
              } catch {
                this.sending_bulk_invite = false;
              }

              for (let i = 0; i < result.length; i++) {
                if (!result[i].group_id || result[i].group_id === 'undefined') {
                  this.convertDocStatusDatesToLocalTimeFromUTC(result[i]);

                  if (added_docs.indexOf(result[i].document_id) <= -1) {
                    this.statuses.push(result[i]);
                    added_docs.push(result[i].document_id);
                  }
                } else if (added_group.indexOf(result[i].group_id) <= -1) {
                  let valid = true;
                  let group_canceled = false;
                  added_group.push(result[i].group_id);
                  const group: any = {
                    is_group: true,
                    valid: valid,
                    group_canceled: group_canceled,
                    group_id: result[i].group_id,
                    invite_id: result[i].invite_id,
                    group_name: result[i].group_name,
                    document_status: []
                  };

                  for (let j = 0; j < result.length; j++) {
                    if (result[i].group_id === result[j].group_id) {
                      if (added_docs.indexOf(result[j].document_id) <= -1) {
                        this.convertDocStatusDatesToLocalTimeFromUTC(result[j]);
                        group.document_status.push(result[j]);
                        added_docs.push(result[j].document_id);
                        if (
                          result[j].status === 'canceled' ||
                          result[j].status === 'fulfilled' ||
                          result[j].valid_token == false
                        ) {
                          valid = false;
                        }
                        if (result[j].status === 'canceled') {
                          group_canceled = true;
                        }
                      }
                    }
                  }

                  group.valid = valid;
                  group.group_canceled = group_canceled;
                  this.statuses.push(group);
                }
              }
            },
            () => {
              this.loading = false;
              this.updateError(this.errorMessages.badLoadStatuses);
            }
          );
      }
    } catch {}
  }

  private convertDocStatusDatesToLocalTimeFromUTC(doc_status: any) {
    doc_status.date_sent = this.helperService.convertUtcToLocalTime(doc_status.date_sent);
    if (doc_status.date_signed !== '') {
      doc_status.date_signed = this.helperService.convertUtcToLocalTime(doc_status.date_signed);
    }
  }

  showPushedbackLog(pushedbackLog) {
    this.isPushedbackLogOpen = true;
    this.currentPushedbackLog = pushedbackLog;
  }

  updateLoading(loadingStatus: boolean = false, msg: string = '') {
    this.loading = loadingStatus;
    this.loadingMessage = msg;
  }
  hideLoading() {
    this.updateLoading(false, '');
  }

  sortFieldInvitesByRoleName(filed_invites) {
    const fieldInvites = JSON.parse(JSON.stringify(filed_invites));

    return fieldInvites.sort((a, b) => {
      const aa = a.role.toLowerCase(),
        bb = b.role.toLowerCase();
      if (aa > bb) {
        return 1;
      }
      if (aa < bb) {
        return -1;
      }
      return 0;
    });
  }
}
